import React from 'react';
import { useIntl } from 'react-intl';
import { range } from 'lodash';
import { Option, Select } from 'carbon-react/lib/components/select';

import { getOrdinalSuffix } from '@futrli/localisation/core/utils';

import { LAST_DAY_OF_MONTH } from '../../../../../core/constants';
import styles from '../../prediction-header-bar/prediction-header-bar.scss';

interface StoreOnTheProps {
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

// eslint-disable-next-line no-magic-numbers
const RANGE_1_31 = range(1, 32);

export const StoreOnThe = ({ disabled, onChange, value }: StoreOnTheProps) => {
  const intl = useIntl();

  return (
    <div className={styles.formInput}>
      <Select
        size="large"
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value}
        label={intl.formatMessage({ id: 'predict.store_on_the', defaultMessage: 'Store on the' })}
        mb={0}
      >
        <Option
          key={LAST_DAY_OF_MONTH}
          value={LAST_DAY_OF_MONTH}
          text={intl.formatMessage({ id: 'predict.last_day_of_month', defaultMessage: 'Last day of the month' })}
        />
        {RANGE_1_31.map(i => (
          <Option key={i} text={getOrdinalSuffix(i, intl.locale)} value={String(i)} />
        ))}
      </Select>
    </div>
  );
};
